<mat-menu yPosition="below" [overlapTrigger]="false">
  @for (item of languages(); track item.code) {
    <button
      type="button"
      mat-menu-item
      [class]="{ 'language-selected': item.code === selectedLanguage().code }"
      (click)="selectLanguage(item)">
      <img class="language-flag" src="\assets\flags\{{ item.code.substr(3, 5).toLowerCase() }}.svg" />{{
      item.displayName
      }}
      ({{ item.code }})
    </button>
  }
</mat-menu>
